import {Component} from '@angular/core';
import {Title} from '@angular/platform-browser';
import {ActivatedRoute} from '@angular/router';
import {AppEnvironmentService} from 'src/app/infrastructure/environment/app-environment/app-environment.service';
import {Router} from 'src/app/infrastructure/router/router';
import StyleStore from 'src/app/infrastructure/store/style.store';
import {Translator} from 'src/app/infrastructure/translation/translator.service';
import {WebPage} from 'src/app/ui/webapp/page/web.page';
import {
  getInvestmentStrategyNameTitleTranslationKey,
  getStrategyIconByName,
  InvestmentStrategyName,
  isAssetIcon,
  isValidStrategyName
} from 'src/app/domain/model/investment-strategy/investment-strategy.model';
import {
  InvestmentStrategyRouteResolverService
} from 'src/app/domain/service/route-resolver/investment-strategy/investment-strategy-route-resolver.service';
import {ProductId} from 'src/app/domain/model/product/product.model';

@Component({
  selector: 'app-investment-strategy-info',
  templateUrl: './investment-strategy-info.page.html',
})
export class InvestmentStrategyInfoPage extends WebPage {
  public investmentStrategyName: string | null;
  public availableInvestmentStrategyNames = InvestmentStrategyName;
  protected investmentStrategyRouteResolver: InvestmentStrategyRouteResolverService;
  protected productId: ProductId;

  constructor(
    private readonly activatedRoute: ActivatedRoute,
    private readonly translator: Translator,
    private readonly styleStore: StyleStore,
    private route: ActivatedRoute,
    router: Router,
    appEnvironment: AppEnvironmentService,
    titleService: Title
  ) {
    super(router, appEnvironment, titleService);
  }

  public get pageTitle(): string {
    const transKey = getInvestmentStrategyNameTitleTranslationKey(this.investmentStrategyName);
    return this.investmentStrategyName
      ? this.translator.trans(transKey)
      : '';
  }

  public get pageIcon(): string {
    const iconName = getStrategyIconByName(this.investmentStrategyName);
    return iconName || '';
  }

  public isAssetIcon(): boolean {
    return isAssetIcon(this.investmentStrategyName);
  }

  protected onInit() {
    super.onInit();
    this.route.data.subscribe(data => {
      this.investmentStrategyRouteResolver = data.investmentStrategyRouteResolver;
    });
    this.styleStore.save({bgColor: 'default', buttons: ['back']});
    this.investmentStrategyName = InvestmentStrategyName[this.router.get('strategyName', this.activatedRoute)] as string;
    this.investmentStrategyName = isValidStrategyName(this.investmentStrategyName) ? this.investmentStrategyName : null;
    this.productId = this.router.get('productId', this.activatedRoute) as ProductId;
  }
}
